export default "__VITE_ASSET__CSyyE5we__"